<template>
  <a :href="`/report/detail/${data.id}`" class="store-card">
    <div class="header">
      <img :src="data.img" />
    </div>
    <div class="body">
      <p class="title">
        {{ data.title || "" }}
      </p>
      <div class="card-content">
        <div class="row">
          <div class="col-5">
            <span><img src="/img/box.png" class="icon" /> Terkumpul</span>
          </div>
          <div class="col-7">
            <span class="value price" v-if="data.core_type == 'campaign'"
              >Rp. {{ data.now || 0 }}</span
            >
            <span class="value" v-else>
              <i class="fa fa-infinity"></i>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-5">
            <span><img src="/img/time.png" class="icon" /> Berakhir</span>
          </div>
          <div class="col-7">
            <span class="value" v-if="data.core_type == 'campaign'">{{
              datevalidate
            }}</span>
            <span class="value" v-else>
              <i class="fa fa-infinity"></i>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-5">
            <span><img src="/img/time.png" class="icon" /> Mitra</span>
          </div>
          <div class="col-7">
            <span class="value">{{ data.mitra ? data.mitra.name : "-" }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-5">
            <span><img src="/img/time.png" class="icon" /> Lembaga</span>
          </div>
          <div class="col-7">
            <span class="value lembaga">{{ data.lembaga.name || "-" }}</span>
          </div>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
import moment from "moment";

export default {
  name: "card",
  props: {
    data: {
      type: Object,
    },
  },
  mounted() {},
  computed: {
    datevalidate() {
      const date = this.data.valid_date
        ? moment(this.data.valid_date).format("DD/MM/YYYY")
        : "";
      return date;
    },
  },
};
</script>

<style></style>
